import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { getHistory } from "@/lib/atsScores";

const KEY = "rpopro_tailored";
const EVT = "rpopro:tailored";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
const write = (l) => { localStorage.setItem(KEY, JSON.stringify(l.slice(0, 50))); window.dispatchEvent(new CustomEvent(EVT)); };

export const addTailored = (e) => {
  const entry = { id: `${e.jobId}-${Date.now()}`, at: new Date().toISOString(), ...e };
  write([entry, ...read().filter((x) => x.file_name !== e.file_name)]);
  api.post("/resume-builder/tailored", entry).catch(() => {});
};

const merge = (remote) => {
  const byName = new Map(read().map((x) => [x.file_name, x]));
  remote.forEach((x) => x?.file_name && !byName.has(x.file_name) && byName.set(x.file_name, x));
  write([...byName.values()].sort((a, b) => (b.at || "").localeCompare(a.at || "")));
};

export const useTailored = () => {
  const [list, setList] = useState(read);
  useEffect(() => {
    const f = () => setList(read());
    window.addEventListener(EVT, f);
    api.get("/resume-builder/tailored").then((r) => Array.isArray(r.data?.items) && merge(r.data.items)).catch(() => {});
    return () => window.removeEventListener(EVT, f);
  }, []);
  return list;
};

const PICK_KEY = "rpopro_autopick";
export const getAutoPick = () => localStorage.getItem(PICK_KEY) !== "0";
export const setAutoPick = (on) => localStorage.setItem(PICK_KEY, on ? "1" : "0");

export const scoresFor = (t) => {
  const h = getHistory(t.jobId);
  const mine = h.filter((x) => x.resume === t.file_name);
  const after = mine.length ? mine : h.filter((x) => x.at >= t.at);
  const before = h.filter((x) => x.at < t.at).at(-1)?.score ?? null;
  return { score: after.at(-1)?.score ?? null, before };
};

export const bestTailoredFor = (jobId) => {
  const rows = read().filter((t) => t.jobId === jobId).map((t) => ({ ...t, score: scoresFor(t).score }));
  if (!rows.length) return null;
  return rows.reduce((m, r) => ((r.score ?? -1) > (m.score ?? -1) ? r : m), rows[0]);
};
